export const FORM_FIELD_PLACEHOLDER_PLACEHOLDER = 'Example: The customer service was excellent';
